// Careers — open roles. Each one links to its own page under /careers/.

import React from 'react';
import { Bay, Card, Eyebrow } from '../primitives.jsx';
import { go } from '../routes.js';
import { jobs } from '../jobs.json';

export default function Careers() {
  return (
    <>
      <Bay band="ground">
        <Eyebrow>Careers</Eyebrow>
        <h1 className="hddn-h1" style={{ marginTop: 18, maxWidth: '13ch' }}>Work with us.</h1>
        <p className="hddn-lede" style={{ marginTop: 22, maxWidth: '54ch' }}>
          Open roles at HDDN Lab, a content studio in downtown New Rochelle.
        </p>
      </Bay>

      <Bay narrow>
        <div style={{ display: 'grid', gap: 'var(--gap)' }}>
          {jobs.map((j) => {
            const href = `/careers/${j.slug}`;
            return (
              <Card key={j.slug}>
                <h2 className="hddn-h3">
                  <a href={href} onClick={go(href)}>{j.title}</a>
                </h2>
                <p className="hddn-label" style={{ marginTop: 10 }}>{j.location}</p>
                <p className="hddn-muted" style={{ marginTop: 14 }}>{j.summary}</p>
                <a href={href} onClick={go(href)} className="hddn-btn hddn-btn--line" style={{ marginTop: 20 }}>
                  View role
                </a>
              </Card>
            );
          })}
        </div>
      </Bay>
    </>
  );
}
